/**
 * Section Animation Observer
 *
 * Triggers entrance animations on sections when they scroll into view.
 * Reads data-animate attribute to determine animation type.
 * Uses IntersectionObserver with a 15% threshold for natural reveal timing.
 *
 * Attributes:
 *   data-animate           – animation type (fade-in, slide-up, slide-in-left, etc.)
 *   data-animate-triggered – added when element enters viewport (triggers CSS animation)
 *
 * CSS custom properties (set via inline style):
 *   --animation-duration   – animation duration
 *   --animation-delay      – animation delay
 *   --animation-easing     – animation easing function
 */

(function initSectionAnimations() {
  'use strict';

  // In design mode: do not run animations (CSS handles visibility)
  if (window.Shopify && window.Shopify.designMode) return;

  // Bail out if IntersectionObserver is unsupported
  if (typeof IntersectionObserver === 'undefined') {
    // Reveal all animated sections immediately
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      el.setAttribute('data-animate-triggered', '');
    });
    return;
  }

  // Respect prefers-reduced-motion: trigger all immediately
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (prefersReducedMotion.matches) {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      el.setAttribute('data-animate-triggered', '');
    });
    return;
  }

  var triggered = new WeakSet();

  var observer = new IntersectionObserver(
    function onIntersect(entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry.isIntersecting) continue;

        var el = entry.target;
        if (triggered.has(el)) continue;

        triggered.add(el);
        el.setAttribute('data-animate-triggered', '');
        observer.unobserve(el);
      }
    },
    { threshold: 0.15 }
  );

  function observeAnimatedSections() {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      if (!triggered.has(el)) {
        observer.observe(el);
      }
    });
  }

  observeAnimatedSections();

  // Re-scan when Shopify injects new sections (theme editor / AJAX)
  new MutationObserver(function () {
    observeAnimatedSections();
  }).observe(document.body, { childList: true, subtree: true });
})();
